import { InjectionToken } from '@angular/core';

export const TRANSLATOR = new InjectionToken<Translator>('Translator');

export interface Translator {
  translate(key: string, args?: { [key: string]: any }): string;
  has(key: string): boolean;
}
